import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsPlusCircle, BsDashCircle } from 'react-icons/bs';

type Props = {
  onMoreClick: () => void;
  size: number;
  tooltipTitle?: string;
};

const MoreColorsSwatch = ({ onMoreClick, size, tooltipTitle = 'More colors' }: Props) => {
  return (
    <OverlayTrigger overlay={<Tooltip>{tooltipTitle}</Tooltip>}>
      <div title={tooltipTitle} data-original-title={tooltipTitle} onClick={onMoreClick}>
        <BsPlusCircle
          className='tw-cursor-pointer tw-text-body tw-transition hover:tw-opacity-75'
          size={size}
        />
      </div>
    </OverlayTrigger>
  );
};

export const LessColorsSwatch = ({ onMoreClick, size, tooltipTitle = 'Less colors' }: Props) => {
  return (
    <OverlayTrigger overlay={<Tooltip>{tooltipTitle}</Tooltip>}>
      <div title={tooltipTitle} data-original-title={tooltipTitle} onClick={onMoreClick}>
        <BsDashCircle
          className='tw-cursor-pointer tw-text-body tw-transition hover:tw-opacity-75'
          size={size}
        />
      </div>
    </OverlayTrigger>
  );
};

export default MoreColorsSwatch;
